import { useRef, useState } from 'react';
import { Form, Input, Button, message, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import CaptchaField, { type CaptchaFieldHandle } from '@/components/CaptchaField';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const register = useAuthStore((s) => s.register);
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef<CaptchaFieldHandle>(null);
  const [form] = Form.useForm<{
    email: string;
    password: string;
    displayName?: string;
    captchaAnswer: string;
  }>();

  const onFinish = async (values: {
    email: string;
    password: string;
    displayName?: string;
    captchaAnswer: string;
  }) => {
    const captchaId = captchaRef.current?.getId();
    if (!captchaId) {
      message.error('请等待验证码加载');
      return;
    }
    setLoading(true);
    try {
      await register(
        values.email,
        values.password,
        captchaId,
        values.captchaAnswer,
        values.displayName,
      );
      message.success('注册成功，已赠送体验金');
      navigate('/home');
    } catch (e) {
      message.error(e instanceof Error ? e.message : '注册失败');
      captchaRef.current?.refresh();
      form.setFieldsValue({ captchaAnswer: '' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-hero">
      <div className="auth-hero__card">
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div className="brand-logo" style={{ fontSize: 26 }}>加入予人智图</div>
          <Typography.Text type="secondary">创作者注册 · 免费开通工作台</Typography.Text>
        </div>
        <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="on">
          <Form.Item name="displayName" label="昵称（可选）">
            <Input size="large" placeholder="展示给同行看的名字" />
          </Form.Item>
          <Form.Item
            name="email"
            label="邮箱"
            rules={[{ required: true, message: '请输入邮箱' }, { type: 'email' }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: '请输入密码' }, { min: 8, message: '至少 8 位' }]}
          >
            <Input.Password size="large" />
          </Form.Item>
          <CaptchaField ref={captchaRef} />
          <Button type="primary" htmlType="submit" loading={loading} block size="large">
            注册
          </Button>
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Typography.Text type="secondary">已有账号？</Typography.Text>{' '}
            <Link to="/login">去登录</Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default RegisterPage;
